import Repository from './Repository'

const action = '/files'

export default {
  approveFiles(modelId, sourceId, type, isApprove, comment) {
    let actionWithParams =
      action + '/approve/' + modelId + '/' + sourceId + '/' + type

    return Repository.post(actionWithParams, { approve: isApprove, comment })
  },
  upload(files, self) {
    return Repository.post(action, files, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress(progressEvent) {
        self.uploadPercentage = parseInt(
          Math.round((progressEvent.loaded * 100) / progressEvent.total),
          10,
        )
      },
    })
  },
  get(modelType, id, typefile) {
    return Repository.get(
      action + '/' + modelType + '/' + id + (typefile ? '/' + typefile : ''),
    )
  },
  dellOne(id) {
    return Repository.delete(action + '/' + id)
  },
  put(modelType, id, typefile, data) {
    return Repository.put(action + '/all', {
      source_id: id,
      type: typefile,
      source_model_id: modelType,
      expire_date: data.dateExpire,
      additional: data.numDoc,
    })
  },
  deleteFile(id) {
    return Repository.delete(action + '/' + id)
  },
  rotate(data) {
    return Repository.post(action + '/rotate', data)
  },
}
